import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Link as LumxLink, Typography } from '@lumapps/lumx/react';
import { Link as RouterLink } from '@lumapps/router';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { MEDIA_TRASH_SCOPE } from '../../constants';
import { mediaTrashRoute } from '../../routes';

export const MediaTrashNewPageLink: React.FC = () => {
    const { get } = useDataAttributes(MEDIA_TRASH_SCOPE);
    const { translateKey } = useTranslate();

    return (
        <LumxLink
            to={mediaTrashRoute}
            linkAs={RouterLink}
            typography={Typography.body1}
            {...get({ element: 'link', action: 'go-to-new-page' })}
        >
            {translateKey(GLOBAL.TRY_NEW_PAGE)}
        </LumxLink>
    );
};
